export default __webpack_public_path__ + "static/media/172.70b96c15.png";